module.exports = __webpack_public_path__ + "img/culture_2.0171b846.jpg";